/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Utilities
   ========================================================================== */
.no-js .u-js-only {
  display: none !important;
}

.u-hide-if-js {
  display: none !important;
}
.no-js .u-hide-if-js {
  display: block !important;
}

.u-clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.u-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  border: 0;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

@media only all and (max-width: 37.5em) {
  .u-hide-on-mobile {
    display: none;
  }
}

.u-show-on-mobile {
  display: none;
}
@media only all and (max-width: 37.5em) {
  .u-show-on-mobile {
    display: block;
  }
}

.u-hidden {
  display: none !important;
}

.u-invisible {
  visibility: hidden;
}

.u-inline-block {
  display: inline-block;
}

.u-right {
  float: right;
}

.u-break-word {
  word-break: break-all;
}

.u-nowrap {
  white-space: nowrap;
}

/* stylelint-disable selector-class-pattern */
.u-flexible-container {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.u-flexible-container__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.u-flexible-container--4-3 {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 75%;
  height: 0;
}

/* stylelint-disable selector-class-pattern */
/* stylelint-enable */
.u-mt0 {
  margin-top: 0 !important;
}

.u-mb0 {
  margin-bottom: 0 !important;
}

.u-mt5 {
  margin-top: 5px !important;
}

.u-mb5 {
  margin-bottom: 5px !important;
}

.u-mt10 {
  margin-top: 10px !important;
}

.u-mb10 {
  margin-bottom: 10px !important;
}

.u-mt15 {
  margin-top: 15px !important;
}

.u-mb15 {
  margin-bottom: 15px !important;
}

.u-mt20 {
  margin-top: 20px !important;
}

.u-mb20 {
  margin-bottom: 20px !important;
}

.u-mt30 {
  margin-top: 30px !important;
}

.u-mb30 {
  margin-bottom: 30px !important;
}

.u-mt45 {
  margin-top: 45px !important;
}

.u-mb45 {
  margin-bottom: 45px !important;
}

.u-mt60 {
  margin-top: 60px !important;
}

.u-mb60 {
  margin-bottom: 60px !important;
}

.u-w100pct {
  width: 100%;
}

.u-w90pct {
  width: 90%;
}

.u-w80pct {
  width: 80%;
}

.u-w70pct {
  width: 70%;
}

.u-w60pct {
  width: 60%;
}

.u-w50pct {
  width: 50%;
}

.u-w40pct {
  width: 40%;
}

.u-w30pct {
  width: 30%;
}

.u-w20pct {
  width: 20%;
}

.u-w10pct {
  width: 10%;
}

.u-w75pct {
  width: 75%;
}

.u-w25pct {
  width: 25%;
}

.u-w66pct {
  width: 66.6666666667%;
}

.u-w33pct {
  width: 33.3333333333%;
}

/* stylelint-disable selector-class-pattern */
small,
.u-small-text {
  /* stylelint-enable */
  font-size: 0.875em;
}

/* ==========================================================================
   Utility classes for transitions.

   Adds transitions utilty classes for transform, opacity,
   and for the removing the transition duration.
   ========================================================================== */
.u-no-animation {
  transition-duration: 0s !important;
}

.u-move-transition {
  transition: transform 0.25s ease-out;
}

.u-move-to-origin {
  transform: translate3d(0, 0, 0);
}

.u-move-left {
  transform: translate3d(-100%, 0, 0);
}

.u-move-left-2x {
  transform: translate3d(-200%, 0, 0);
}

.u-move-left-3x {
  transform: translate3d(-300%, 0, 0);
}

.u-move-right {
  transform: translate3d(100%, 0, 0);
}

.u-move-up {
  transform: translate3d(0, -100%, 0);
}

.u-alpha-transition {
  transition: opacity 0.25s linear;
}

.u-alpha-100 {
  opacity: 1;
}

.u-alpha-0 {
  opacity: 0;
}

.u-max-height-transition {
  overflow: hidden;
  contain: paint;
  transition: max-height 0.2s ease-out;
}

/*
.u-max-height-default {
  This class is kept for documentation completeness.
  The actual max-height is set in the JavaScript,
  so that we know what the actual height of the content is for easing purposes.
}
*/
.u-max-height-zero {
  max-height: 0 !important;
}

.u-max-height-summary {
  /* The value set here should show 4 lines of text at our standard 16px
     base font size. The calculation comes from the following:
     88px = 16 * 5.5em.
     5.5em = base-line-height (22px) * 4 / base-font-size (16px)
  */
  max-height: 88px !important;
}

/* ==========================================================================
   consumerfinance.gov
   tag
   ========================================================================== */
.a-tag-filter {
  display: flex;
  gap: 0.625rem;
  border: 1px solid var(--teal);
  padding: 4px 6px;
  background-color: var(--teal-20);
  border-radius: 0.1875rem;
  color: var(--black);
  text-align: left;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.a-tag-filter:hover {
  background-color: var(--teal-40);
  cursor: pointer;
}
.a-tag-filter:focus {
  outline: 1px dotted var(--teal);
  outline-offset: 1px;
}
.a-tag-filter:active {
  background-color: var(--teal);
}
.a-tag-filter .cf-icon-svg {
  pointer-events: none;
  flex: none;
}
.a-tag-filter > label {
  display: contents;
  pointer-events: none;
}

a.a-tag-filter {
  color: var(--black);
  border-color: var(--black);
}
a.a-tag-filter:visited, a.a-tag-filter.visited {
  border-color: var(--black);
  color: var(--black);
}
a.a-tag-filter:hover, a.a-tag-filter.hover {
  border-color: var(--black);
  color: var(--black);
}
a.a-tag-filter:focus, a.a-tag-filter.focus {
  border-color: var(--black);
  color: var(--black);
}
a.a-tag-filter:active, a.a-tag-filter.active {
  border-color: var(--black);
  color: var(--black);
}

.a-tag-topic {
  display: flex;
  gap: 0.3125rem;
}

.a-tag-topic {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--gold-80);
  letter-spacing: 1px;
}
.a-tag-topic .a-tag-topic__text {
  color: var(--gray);
  word-break: break-word;
}
@media only all and (max-width: 37.5em) {
  .a-tag-topic {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.3125rem;
    box-sizing: border-box;
    padding-top: 0.625em;
    padding-bottom: 0.625em;
    width: 100%;
  }
  .a-tag-topic .cf-icon-svg--right {
    margin-left: auto;
  }
  .a-tag-topic .a-tag-topic__text {
    border-bottom-width: 0;
    flex-shrink: 10;
  }
}

a.a-tag-topic {
  border-color: var(--gold-80);
  color: var(--gold-80);
  border-color: var(--gold-80);
}
a.a-tag-topic:visited, a.a-tag-topic.visited {
  border-color: var(--gold-80);
  color: var(--gold-80);
}
a.a-tag-topic:hover, a.a-tag-topic.hover {
  border-color: var(--gold-80);
  color: var(--gold-80);
}
a.a-tag-topic:focus, a.a-tag-topic.focus {
  border-color: var(--gold-80);
  color: var(--gold-80);
}
a.a-tag-topic:active, a.a-tag-topic.active {
  border-color: var(--gold-80);
  color: var(--gold-80);
}
a.a-tag-topic .a-tag-topic__text {
  border-bottom-color: var(--gold-80);
}
@media only all and (max-width: 37.5em) {
  a.a-tag-topic {
    border-top-width: 1px;
    border-bottom-width: 1px;
  }
  a.a-tag-topic:focus {
    outline: none;
  }
  a.a-tag-topic:focus::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    outline: 1px dotted var(--gray);
    outline-offset: 2px;
  }
}

@media only all and (max-width: 37.5em) {
  li:has(.a-tag-topic) + li:has(.a-tag-topic) .a-tag-topic {
    position: relative;
    border-top: none;
  }
  li:has(.a-tag-topic) + li:has(.a-tag-topic) a.a-tag-topic:hover::before,
  li:has(.a-tag-topic) + li:has(.a-tag-topic) a.a-tag-topic:focus::before {
    position: absolute;
    top: -1px;
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    border-top: 1px solid currentcolor;
  }
}
.a-tag-topic__bullet {
  font-size: 1rem;
  line-height: 1rem;
}

@media only all and (min-width: 37.5625em) {
  a.a-tag-topic__text {
    color: var(--gray);
    border-color: var(--gray);
  }
  a.a-tag-topic__text:visited, a.a-tag-topic__text.visited {
    border-color: var(--gray);
    color: var(--gray);
  }
  a.a-tag-topic__text:hover, a.a-tag-topic__text.hover {
    border-color: var(--gray);
    color: var(--gray);
  }
  a.a-tag-topic__text:focus, a.a-tag-topic__text.focus {
    border-color: var(--gray);
    color: var(--gray);
  }
  a.a-tag-topic__text:active, a.a-tag-topic__text.active {
    border-color: var(--gray);
    color: var(--gray);
  }
  a.a-tag-topic,
  a.a-tag-topic:visited,
  a.a-tag-topic:hover,
  a.a-tag-topic:focus,
  a.a-tag-topic:active {
    border-bottom: none;
    outline-offset: 1px;
  }
  a.a-tag-topic .a-tag-topic__text,
  a.a-tag-topic:visited .a-tag-topic__text,
  a.a-tag-topic:hover .a-tag-topic__text,
  a.a-tag-topic:focus .a-tag-topic__text,
  a.a-tag-topic:active .a-tag-topic__text {
    padding-bottom: 1px;
    border-bottom: 1px dotted var(--gold-80);
  }
  a.a-tag-topic:hover .a-tag-topic__text {
    border-bottom: 1px solid var(--gold-80);
  }
  a.a-tag-topic:focus {
    outline-color: var(--gray);
  }
  a.a-tag-topic:focus .a-tag-topic__text {
    border-bottom-style: solid !important;
  }
}
.m-tag-group {
  padding-left: 0;
  list-style-type: none;
}
.m-tag-group li {
  margin-bottom: 0;
  display: contents;
}
@media only all and (min-width: 37.5625em) {
  .m-tag-group {
    display: flex;
    gap: 0.9375em;
    flex-wrap: wrap;
  }
  .m-tag-group--stacked {
    flex-direction: column;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.m-tag-group:has(.a-tag-filter) {
  display: flex;
  gap: 0.9375em;
  flex-wrap: wrap;
}

html[lang=ar] .m-tag-group {
  direction: rtl;
  padding-right: 0;
}